import {Component, Input, OnInit, ViewChild, forwardRef} from '@angular/core';
import {ContractorService} from '@app/layout/admin/services/contractors/contractor.service';
import {Contractor} from '@app/layout/admin/services/api/contractor-interfaces';
import {PagedModel} from '../../api/model/paged-model';
import {finalize} from 'rxjs/operators';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {MessageTranslateService} from '@shared/services';

@Component({
  selector: 'app-contractor-select',
  templateUrl: './contractor-select.component.html',
  styleUrls: ['./contractor-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ContractorSelectComponent),
    multi: true
  }],
  standalone: false
})
export class ContractorSelectComponent implements OnInit, ControlValueAccessor {

  readonly MAX_ITEMS = 3;

  @Input()
  multiSelect = false;
  @Input()
  placeholder: string;

  contractors: Contractor[];
  selectedContractors: Contractor | Contractor[];
  loading = false;

  @ViewChild('aceSelect', { static: true })
  private aceSelect: AceSelectComponent;

  private onChange: (_) => void = (_) => {};
  private onTouched: () => void = () => {};

  constructor(private translateService: MessageTranslateService,
              private contractorsService: ContractorService) {
  }

  ngOnInit() {
    if (this.placeholder === undefined) {
      this.placeholder = this.translateService.instant('Contractors');
    }

    this.loading = true;
    this.contractorsService.getContractors(0, 10000).pipe(finalize(() => this.loading = false))
      .subscribe(({count: count, data: data}: PagedModel<Contractor[]>) => {
        this.contractors = data;
      });

    this.aceSelect.registerOnChange(this.aceSelectChange);
    this.aceSelect.registerOnTouched(this.aceSelectTouched);
  }

  aceSelectChange = (selected: Contractor | Contractor[]) => {
    this.selectedContractors = selected;
    this.onChange(selected);
  };

  aceSelectTouched = () => {
    this.onTouched();
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  writeValue(obj: any): void {
    this.selectedContractors = obj;
    this.aceSelect.writeValue(obj);
  }

  compareFn(a: Contractor, b: Contractor): boolean {
    return a.id === b.id;
  }
}
